import script from "./Creators.vue?vue&type=script&setup=true&lang=js"
export * from "./Creators.vue?vue&type=script&setup=true&lang=js"

import "./Creators.vue?vue&type=style&index=0&id=4c955112&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c955112"]])

export default __exports__